module.exports = __webpack_public_path__ + "static/media/header-network-matic.8766cff0.svg";